import { AUTO_STOCK_SLIP_LABELS } from '@/utils/stockSlipOrigin'

export const SideBar = {
  TRADE_IN: [
    {
      name: 'Chương trình thu cũ - đổi mới',
      icon: 'menu-icon fas fa-tools',
      route: '/trade-in-programs',
      actions: ['TRADE_IN_PROGRAM_VIEW'],
    },
    {
      name: 'Phiếu định giá',
      icon: 'menu-icon far fa-file-alt',
      route: '/trade-in',
      actions: ['TRADE_IN_VIEW'],
    },
    {
      name: 'Phiếu thu cũ',
      icon: 'menu-icon far fa-file-alt',
      route: '/import-trade-in',
      actions: ['TRADE_IN_VIEW'],
    },
  ],
  ORDER: [
    {
      name: 'Đơn hàng',
      icon: 'menu-icon flaticon2-supermarket',
      route: '/orders',
      actions: ['ORDER_VIEW'],
      excludeWhenActive: ['/orders/platform'],
    },
    {
      name: 'Danh sách đơn sàn',
      icon: 'menu-icon flaticon2-delivery-package',
      route: '/orders/platform',
      actions: ['ECOM_ORDER_VIEW'],
    },
    {
      name: 'Đơn đặt trước',
      icon: 'menu-icon flaticon2-supermarket',
      route: '/pre-order',
      actions: ['PRE_ORDER_VIEW'],
    },
    {
      name: 'Nguồn đơn hàng',
      icon: 'menu-icon flaticon2-delivery-package',
      route: '/order-source',
      actions: ['ORDER_SOURCE_VIEW'],
    },
  ],
  PRODUCT: [
    {
      name: 'Sản phẩm',
      icon: 'menu-icon flaticon-tool',
      route: '/products',
      actions: ['PRODUCT_VIEW'],
    },
    {
      name: 'Danh mục sản phẩm',
      icon: 'menu-icon flaticon2-menu-1',
      route: '/categories',
      actions: ['CATE_VIEW'],
    },
    {
      name: 'Danh mục linh kiện',
      icon: 'menu-icon fas fa-tools',
      route: '/product-component-categories',
      actions: ['PRODUCT_COMPONENT_CATE_VIEW'],
    },
    {
      name: 'Linh kiện',
      icon: 'menu-icon fas fa-tools',
      route: '/product-component',
      actions: ['PRODUCT_COMPONENT_VIEW'],
    },
    {
      name: 'Thương hiệu',
      icon: 'menu-icon flaticon-bell-1',
      route: '/brands',
      actions: ['BRAND_VIEW'],
    },
    // {
    //   name: 'Hình ảnh',
    //   icon: 'menu-icon flaticon-bell-1',
    //   route: '/images',
    //   actions: ['PRODUCT_VIEW'],
    // },
  ],
  STOCK_SLIP: [
    {
      name: 'Nhập kho',
      icon: 'menu-icon flaticon2-supermarket',
      route: '/inventory-receipt',
      actions: ['STOCK_IMPORT_VIEW'],
    },
    {
      name: 'Xuất kho',
      icon: 'menu-icon flaticon2-delivery-package',
      route: '/inventory-dispatch',
      actions: ['STOCK_EXPORT_VIEW'],
    },
    {
      name: AUTO_STOCK_SLIP_LABELS.MENU_PARENT,
      icon: 'menu-icon fas fa-file-invoice',
      route: '#',
      actions: ['STOCK_IMPORT_VIEW', 'STOCK_EXPORT_VIEW'],
      submenu: [
        {
          name: AUTO_STOCK_SLIP_LABELS.MENU_IMPORT,
          icon: 'menu-icon flaticon2-supermarket',
          route: '/inventory-receipt-auto',
          actions: ['STOCK_IMPORT_VIEW'],
        },
        {
          name: AUTO_STOCK_SLIP_LABELS.MENU_EXPORT,
          icon: 'menu-icon flaticon2-delivery-package',
          route: '/inventory-dispatch-auto',
          actions: ['STOCK_EXPORT_VIEW'],
        },
      ],
    },
    {
      name: 'Chuyển kho',
      icon: 'menu-icon flaticon2-delivery-package',
      route: '#',
      actions: ['STOCK_TRANSFER_REQUEST_VIEW', 'STOCK_TRANSFER_VIEW'],
      submenu: [
        {
          name: 'Phiếu yêu cầu',
          icon: 'menu-icon fas fa-file-alt',
          route: '/request-transfer',
          actions: ['STOCK_TRANSFER_REQUEST_VIEW'],
        },
        {
          name: 'Phiếu chuyển',
          icon: 'menu-icon fas fa-store',
          route: '/inventory-transfer',
          actions: ['STOCK_TRANSFER_VIEW'],
        },
      ],
    },
    {
      name: 'Nhập hàng lỗi',
      icon: 'menu-icon flaticon2-supermarket',
      route: '/defective-goods-transfer',
      actions: ['STOCK_DEFECTIVE_IMPORT_VIEW'],
    },
    {
      name: 'Xuất hàng lỗi',
      icon: 'menu-icon flaticon2-delivery-package',
      route: '/defective-goods-export',
      actions: ['STOCK_DEFECTIVE_EXPORT_VIEW'],
    },
    {
      name: 'Phục hồi hàng lỗi',
      icon: 'menu-icon flaticon2-refresh',
      route: '/defective-goods-restoration',
      actions: ['STOCK_DEFECTIVE_RESTORATION_VIEW'],
    },
    {
      name: 'Phiếu cho mượn',
      icon: 'menu-icon fas fa-hand-holding',
      route: '/lending-stockslip',
      actions: ['STOCK_LENDING_VIEW'],
    },
    {
      name: 'Đặt hàng nhập',
      icon: 'menu-icon flaticon2-supermarket',
      route: '/purchase-orders',
      actions: ['PO_VIEW'],
    },
    {
      name: 'Nhập kho đầu kỳ',
      icon: 'menu-icon flaticon2-supermarket',
      route: '/opening-stock-receipt',
      actions: ['STOCK_IMPORT_VIEW'],
    },
    {
      name: 'Tồn kho',
      icon: 'menu-icon flaticon2-supermarket',
      route: '/productStock',
      actions: ['STOCK_VIEW'],
    },
    {
      name: 'Kiểm kho',
      icon: 'menu-icon flaticon2-crisp-icons',
      route: '/inventory-check',
      actions: ['STOCK_CHECK_VIEW'],
    },
    {
      name: 'Giá vốn theo kỳ',
      icon: 'menu-icon fas fa-calculator',
      route: '/inventory-cost-recalculation',
      actions: ['COST_RECALCULATION_VIEW', 'COST_RECALCULATION_COMPUTE', 'COST_RECALCULATION_APPLY'],
    },
    {
      name: 'Giá vốn đầu kỳ',
      icon: 'menu-icon fas fa-coins',
      route: '/opening-balance-cost',
      actions: ['OPENING_BALANCE_COST_VIEW', 'OPENING_BALANCE_COST_EDIT'],
    },
    {
      name: 'Danh sách IMEI',
      icon: 'menu-icon fas fa-barcode',
      route: '/imeis',
      actions: ['IMEI_LIST_VIEW'],
      excludeWhenActive: ['/imeis/production-order-list', '/imeis/production-order'],
    },
    {
      name: 'Danh sách lệnh sản xuất',
      icon: 'menu-icon fas fa-cogs',
      route: '/imeis/production-order-list',
      actions: ['PRODUCTION_ORDER_VIEW'],
    },
    {
      name: 'Lịch sử IMEI',
      icon: 'menu-icon fas fa-history',
      route: '/imei-histories',
      actions: ['IMEI_HISTORY_VIEW'],
    },
    {
      name: 'Báo cáo xuất nhập kho',
      icon: 'menu-icon fas fa-chart-bar',
      route: '/stock-slip-reports',
      actions: ['STOCK_SLIP_REPORT_VIEW'],
    },
  ],
  WARRANTY: [
    {
      name: 'Dịch vụ',
      icon: 'menu-icon fas fa-tools',
      route: '/warranty-receptions',
      actions: ['WARRANTY_RECEPTION_VIEW', 'WARRANTY_VIEW'],
      submenu: [
        {
          name: 'Tiếp nhận',
          icon: 'menu-icon fas fa-clipboard-check',
          route: '/warranty-receptions',
          actions: ['WARRANTY_RECEPTION_VIEW'],
        },
        {
          name: 'Điều phối',
          icon: 'menu-icon fas fa-tasks',
          route: '/warranty-dispatches',
          actions: ['WARRANTY_VIEW'],
        },
        {
          name: 'Từ chối bảo hành',
          icon: 'menu-icon fas fa-times-circle',
          route: '/warranty-rejections',
          actions: ['WARRANTY_VIEW'],
        },
        {
          name: 'Phiếu outsource',
          icon: 'menu-icon fas fa-truck-loading',
          route: '/warranty-outsource',
          actions: ['WARRANTY_VIEW'],
        },
      ],
    },
    {
      name: 'Báo cáo',
      icon: 'menu-icon fas fa-chart-line',
      route: '/warranty-reports/detail',
      actions: [
        'WARRANTY_REPORT_VIEW',
        'WARRANTY_REPORT_SUMMARY_VIEW',
        'WARRANTY_REPORT_BY_EMPLOYEE_VIEW',
      ],
      submenu: [
        {
          name: 'Báo cáo tổng hợp',
          icon: 'menu-icon fas fa-chart-pie',
          route: '/warranty-reports/detail',
          actions: ['WARRANTY_REPORT_VIEW'],
        },
        {
          name: 'Báo cáo tiền',
          icon: 'menu-icon fas fa-file-invoice-dollar',
          route: '/warranty-reports/summary',
          actions: ['WARRANTY_REPORT_SUMMARY_VIEW'],
        },
        {
          name: 'Báo cáo theo nhân viên',
          icon: 'menu-icon fas fa-user-cog',
          route: '/warranty-reports/by-employee',
          actions: ['WARRANTY_REPORT_BY_EMPLOYEE_VIEW'],
        },
      ],
    },
    {
      name: 'Giải pháp',
      icon: 'menu-icon fas fa-lightbulb',
      route: '/solutions',
      actions: ['WARRANTY_SOLUTION_CONFIG_VIEW'],
    },
    {
      name: 'Mức độ lỗi',
      icon: 'menu-icon fas fa-exclamation-triangle',
      route: '/error-severity',
      actions: ['ERROR_LEVEL_VIEW'],
    },
    {
      name: 'Nhóm lỗi',
      icon: 'menu-icon fas fa-layer-group',
      route: '/error-group',
      actions: ['ERROR_GROUP_VIEW'],
    },
    {
      name: 'Lỗi kỹ thuật',
      icon: 'menu-icon fas fa-wrench',
      route: '/technical-error',
      actions: ['WARRANTY_ERROR_CONFIG_VIEW'],
    },
    {
      name: 'Thiết bị kèm theo',
      icon: 'menu-icon fas fa-box-open',
      route: '/accompanying-equipment',
      actions: ['ACCOMPANYING_EQUIPMENT_VIEW'],
    },
    {
      name: 'Loại dịch vụ',
      icon: 'menu-icon fas fa-cogs',
      route: '/warranty-services',
      actions: ['WARRANTY_SERVICE_VIEW'],
    },
  ],
  CUSTOMER: [
    {
      name: 'Khách hàng/nhà cung cấp',
      icon: 'menu-icon flaticon-bell-1',
      route: '/customers',
      actions: ['CUSTOMER_VIEW'],
    },
    {
      name: 'Điểm tích lũy',
      icon: 'menu-icon flaticon2-group',
      route: '/points',
      actions: ['POINT_VIEW'],
    },
    {
      name: 'Nhà cung cấp',//predicate
      icon: 'menu-icon flaticon2-delivery-truck',
      route: '/providers',
      actions: ['PROVIDER_VIEW'],
    },
    // {
    //   name: 'Nhóm nhà cung cấp',
    //   icon: 'menu-icon flaticon2-delivery-truck',
    //   route: '/supplier-groups',
    //   actions: ['PROVIDER_VIEW'],
    // },
    {
      name: 'Loại khách hàng/nhà cung cấp',
      icon: 'menu-icon flaticon2-user',
      route: '/customer-types',
      actions: ['CUSTOMER_TYPE_VIEW'],
    },
  ],
  CONFIG: [
    {
      name: 'Cửa hàng',
      icon: 'menu-icon fas fa-landmark',
      route: '#',
      actions: ['STORE_VIEW', 'COMPANY_VIEW', 'TRANSFER_STORE_FORM_VIEW'],
      submenu: [
        {
          name: 'Doanh nghiệp',
          icon: 'menu-icon fas fa-building',
          route: '/companies',
          actions: ['COMPANY_VIEW'],
        },
        {
          name: 'Cửa hàng',
          icon: 'menu-icon fas fa-store',
          route: '/stores',
          actions: ['STORE_VIEW'],
        },
        {
          name: 'Phiếu chuyển cửa hàng',
          icon: 'menu-icon fas fa-store',
          route: '/transfer-store-forms',
          actions: ['TRANSFER_STORE_FORM_VIEW'],
        },
      ],
    },
    {
      name: 'Tài khoản',
      icon: 'menu-icon fas fa-street-view',
      route: '#',
      actions: ['EMPLOYEE_VIEW', 'USER_VIEW', 'ROLE_VIEW'],
      submenu: [
        {
          name: 'Nhân sự',
          icon: 'menu-icon fas fa-people-arrows',
          route: '/employees',
          actions: ['EMPLOYEE_VIEW'],
        },
        {
          name: 'Tài khoản',
          icon: 'menu-icon flaticon2-user',
          route: '/users',
          actions: ['USER_VIEW'],
        },
        {
          name: 'Bảo mật & Phân quyền',
          icon: 'menu-icon fas fa-user-cog',
          route: '/permissions',
          actions: ['ROLE_VIEW'],
        },
      ],
    },
    {
      name: 'Khuyến mãi',
      icon: 'menu-icon flaticon2-gift',
      route: '#',
      actions: ['VOUCHER_VIEW'],
      submenu: [
        {
          name: 'Voucher sản phẩm',
          icon: 'menu-icon fas fa-ticket-alt',
          route: '/voucher',
          actions: ['VOUCHER_VIEW'],
        },
      ],
    },
    {
      name: 'Ngành hàng',
      icon: 'menu-icon fas fa-gifts',
      route: '#',
      actions: ['PRO_ACCTACH_VIEW', 'PRO_PROMOTION_VIEW', 'WARRANTY_PACKAGE_VIEW', 'DISCOUNT_VIEW', 'FLEXIBLE_COMBO_VIEW', 'DEALSHEET_VIEW'],
      submenu: [
        {
          name: 'Bộ phụ kiện tặng kèm',
          icon: 'menu-icon fas fa-gift',
          route: '/accessories',
          actions: ['PRO_ACCTACH_VIEW'],
        },
        {
          name: 'Bộ phụ kiện bán kèm',
          icon: 'menu-icon fas fa-tags',
          route: '/promotion-accessories',
          actions: ['PRO_PROMOTION_VIEW'],
        },
        {
          name: 'Gói bảo hành',
          icon: 'menu-icon fas fa-award',
          route: '/warranty-packages',
          actions: ['WARRANTY_PACKAGE_VIEW'],
        },
        {
          name: 'Giảm giá khuyến mãi',
          icon: 'menu-icon fas fa-arrow-down',
          route: '/discount-programs',
          actions: ['DISCOUNT_VIEW'],
        },
        {
          name: 'Bộ combo',
          icon: 'menu-icon flaticon2-supermarket',
          route: '/flexible-combo',
          actions: ['FLEXIBLE_COMBO_VIEW'],
        },
        {
          name: 'Quản lý deal sheet',
          icon: 'menu-icon fas fa-gift',
          route: '/deal-sheets',
          actions: ['DEALSHEET_VIEW'],
          submenu: [
            {
              name: 'Danh sách deal sheet',
              icon: 'menu-icon fas fa-list',
              route: '/deal-sheets',
              actions: ['DEALSHEET_VIEW'],
            },
            {
              name: 'Thông tin deal sheet',
              icon: 'menu-icon fas fa-info-circle',
              route: '/deal-sheets/info',
              actions: ['DEALSHEET_VIEW'],
            },
          ],
        },
      ],
    },
    {
      name: 'Cấu hình duyệt chi',
      icon: 'menu-icon flaticon2-settings',
      route: '/approval-configs',
      actions: ['APPROVAL_CONFIG_VIEW'],
    },
    {
      name: 'Cài đặt',
      icon: 'menu-icon flaticon2-settings',
      route: '#',
      actions: ['SETTING_VIEW', 'IP_WHITELIST_VIEW', 'IP_BYPASS_VIEW'],
      submenu: [
        {
          name: 'Cài đặt hệ thống',
          icon: 'menu-icon flaticon2-settings',
          route: '/settings',
          actions: ['SETTING_VIEW'],
        },
        {
          name: 'Cài đặt nhà vận chuyển',
          icon: 'menu-icon flaticon2-settings',
          route: '/settings/shipping-carriers',
          actions: ['SETTING_VIEW'],
        },
        {
          name: 'Kiểm soát truy cập IP',
          icon: 'menu-icon fas fa-shield-alt',
          route: '/ip-access-control',
          actions: ['IP_WHITELIST_VIEW', 'IP_BYPASS_VIEW'],
        },
      ],
    },
  ],
  ACCOUNTANT: [
    {
      name: 'Thu chi tiền mặt',
      icon: 'menu-icon fas fa-money-bill',
      route: '/accounting/transactions/cash',
      actions: ['TRANSACTION_VIEW'],
    },
    {
      name: 'Thu chi ngân hàng',
      icon: 'menu-icon fas fa-university',
      route: '/accounting/transactions/bank',
      actions: ['TRANSACTION_VIEW'],
    },
    {
      name: 'Tổng hợp thu chi',
      icon: 'menu-icon fas fa-receipt',
      route: '/accounting/transactions/cashbook',
      actions: ['TRANSACTION_VIEW'],
    },
    {
      name: 'Công nợ',
      icon: 'menu-icon fas fa-balance-scale',
      route: '#',
      actions: ['DEBT_PROVIDER_VIEW', 'DEBT_PROVIDER_DUE_DATE_VIEW', 'INSTALLMENT_VIEW', 'DEBT_INSTALLMENT_BILL_VIEW', 'DEBT_INSTALLMENT_ORDER_VIEW', 'DEBT_CREDIT_VIEW', 'DEBT_CREDIT_ORDER_VIEW', 'DEBT_SHIP_FEE_ORDER_VIEW', 'DEBT_WARRANTY_INSTALLMENT_VIEW'],
      submenu: [
        {
          name: 'Công nợ khách hàng/nhà cung cấp',
          icon: 'menu-icon fas fa-truck',
          route: '/accounting/debts/providers',
          actions: ['DEBT_PROVIDER_VIEW'],
        },
        {
          name: 'Hạn thanh toán nhà cung cấp',
          icon: 'menu-icon fas fa-clock',
          route: '/accounting/debts/supplier-due-date',
          actions: ['DEBT_PROVIDER_DUE_DATE_VIEW'],
        },
        {
          name: 'Dịch vụ trả góp',
          icon: 'menu-icon fas fa-calendar-check',
          route: '/accounting/debts/installments',
          actions: ['INSTALLMENT_VIEW'],
        },
        {
          name: 'Trả góp hóa đơn',
          icon: 'menu-icon fas fa-file-invoice-dollar',
          route: '/accounting/debts/installment-bill',
          actions: ['DEBT_INSTALLMENT_BILL_VIEW'],
        },
        {
          name: 'Trả góp đơn hàng',
          icon: 'menu-icon fas fa-shopping-cart',
          route: '/accounting/debts/installment-orders',
          actions: ['DEBT_INSTALLMENT_ORDER_VIEW'],
        },
        {
          name: 'Quẹt thẻ hóa đơn',
          icon: 'menu-icon fas fa-credit-card',
          route: '/accounting/debts/credits',
          actions: ['DEBT_CREDIT_VIEW'],
        },
        {
          name: 'Quẹt thẻ đơn hàng',
          icon: 'menu-icon fas fa-credit-card',
          route: '/accounting/debts/credit-order',
          actions: ['DEBT_CREDIT_ORDER_VIEW'],
        },
        {
          name: 'Phí ship đơn hàng',
          icon: 'menu-icon fas fa-shipping-fast',
          route: '/accounting/debts/ship-fee-order',
          actions: ['DEBT_SHIP_FEE_ORDER_VIEW'],
        },
        {
          name: 'Trả góp bảo hành',
          icon: 'menu-icon fas fa-file-invoice-dollar',
          route: '/accounting/debts/warranty-installment',
          actions: ['DEBT_WARRANTY_INSTALLMENT_VIEW'],
        },
      ],
    },
    {
      name: 'Tài khoản kế toán',
      icon: 'menu-icon fas fa-file-invoice-dollar',
      route: '/accounting/accounts',
      actions: ['ACCOUNTANT_VIEW'],
    },
    {
      name: 'Danh mục thu chi',
      icon: 'menu-icon fas fa-file-signature',
      route: '/transaction-categories',
      actions: ['TRANSACTION_CATE_VIEW'],
    },
    {
      name: 'Dịch vụ trả góp',
      icon: 'menu-icon fas fa-file-signature',
      route: '/accounting/installments',
      actions: ['INSTALLMENT_VIEW'],
    },
    {
      name: 'Giải ngân công nợ',
      icon: 'menu-icon fas fa-file-signature',
      route: '#',
      actions: ['DISBURSEMENT_VIEW', 'DISBURSEMENT_CONFIG_VIEW'],
      submenu: [
        {
          name: 'Danh sách giải ngân',
          icon: 'menu-icon fas fa-file-signature',
          route: '/disbursement',
          actions: ['DISBURSEMENT_VIEW'],
        },
        {
          name: 'Cấu hình nhà giải ngân',
          icon: 'menu-icon fas fa-sliders-h',
          route: '/disbursement/configs',
          actions: ['DISBURSEMENT_CONFIG_VIEW'],
        },
      ],
    },
    {
      name: 'Phiếu yêu cầu duyệt chi',
      icon: 'menu-icon fas fa-file-signature',
      route: '/approval',
      actions: ['APPROVAL_VIEW'],
    },
  ],
  REPORT: [
    {
      name: 'Kế toán',
      icon: 'menu-icon fas fa-file-invoice-dollar',
      route: '#',
      actions: ['REPORT_TRANSACTION_STORE_VIEW'],
      submenu: [
        {
          name: 'Thu chi theo cửa hàng',
          icon: 'menu-icon fas fa-store',
          route: '/reports/accounting/cash',
          actions: ['REPORT_TRANSACTION_STORE_VIEW'],
        },
      ],
    },
    {
      name: 'Hoa hồng cửa hàng',
      icon: 'menu-icon fas fa-file-invoice-dollar',
      route: '/reward-reports/overview',
      actions: ['RR_VIEW_ALL'],
    },
    {
      name: 'Hoa hồng CSKH',
      icon: 'menu-icon fas fa-file-invoice-dollar',
      route: '/reward-cr-reports/overview',
      actions: ['CR_VIEW_ALL'],
    },
    {
      name: 'Báo cáo XNT',
      icon: 'menu-icon fas fa-warehouse',
      route: '/reports/inventory-summary',
      actions: ['INVENTORY_SUMMARY_REPORT_VIEW'],
    },
    {
      name: 'Báo cáo doanh thu theo sản phẩm',
      icon: 'menu-icon fas fa-chart-bar',
      route: '/reports/product-revenue-report',
      actions: ['PRODUCT_REVENUE_REPORT_VIEW'],
    },
    {
      name: 'Báo cáo bán hàng',
      icon: 'menu-icon fas fa-chart-area',
      route: '/reports/sales-reports',
      actions: ['SALES_REPORT_VIEW'],
    },
    {
      name: 'Báo cáo lãi lỗ',
      icon: 'menu-icon fas fa-chart-line',
      route: '/reports/profit-loss',
      actions: ['BILL_REVENUE_REPORT_VIEW', 'PRODUCT_IMEI_REVENUE_REPORT_VIEW'],
      submenu: [
        {
          name: 'Báo cáo theo hoá đơn',
          icon: 'menu-icon fas fa-chart-pie',
          route: '/reports/profit-loss/by-bill',
          actions: ['BILL_REVENUE_REPORT_VIEW'],
        },
        {
          name: 'Báo cáo theo sản phẩm IMEI',
          icon: 'menu-icon fas fa-user-cog',
          route: '/reports/profit-loss/by-product-imei',
          actions: ['PRODUCT_IMEI_REVENUE_REPORT_VIEW'],
        },
      ],
    },
  ],
  BILL: [
    {
      name: 'Hóa đơn bán lẻ',
      icon: 'menu-icon fas fa-receipt',
      route: '/bills',
      actions: ['BILL_VIEW'],
    },
    {
      name: 'Hóa đơn giao hàng',
      icon: 'menu-icon fas fa-shipping-fast',
      route: '/delivery-bills',
      actions: ['BILL_DELIVERY_VIEW'],
    },
    {
      name: 'Hóa đơn bán buôn',
      icon: 'menu-icon fas fa-truck-loading',
      route: '/wholesale-invoice',
      actions: ['BILL_WHOLESALE_VIEW'],
    },
    {
      name: 'Hóa đơn trả hàng',
      icon: 'menu-icon flaticon-reply',
      route: '/refund-bills',
      actions: ['BILL_VIEW', 'BILL_WHOLESALE_VIEW', 'BILL_DELIVERY_VIEW'],
    },
    {
      name: 'Hoá đơn điện tử',
      icon: 'menu-icon fas fa-file-invoice',
      route: '/einvoices',
      actions: ['EINVOICE_VIEW', 'EINVOICE_ADJUSTMENT_VIEW'],
      submenu: [
        {
          name: 'Danh sách hoá đơn GTGT',
          icon: 'menu-icon fas fa-file-alt',
          route: '/einvoices',
          actions: ['EINVOICE_VIEW'],
        },
        {
          name: 'Danh sách hoá đơn điều chỉnh GTGT',
          icon: 'menu-icon fas fa-file-signature',
          route: '/einvoices/adjustment-drafts',
          actions: ['EINVOICE_ADJUSTMENT_VIEW'],
        },
      ],
    },
  ],
  REWARD: [
    {
      name: 'Hoa hồng',
      icon: 'menu-icon fas fa-gift',
      route: '#',
      actions: ['REWARD_PRODUCT_CATEGORY_VIEW', 'REWARD_PROGRAM_VIEW', 'REWARD_DETAIL_VIEW', 'REWARD_CHECK_VIEW'],
      submenu: [
        {
          name: 'Nhóm sản phẩm',
          icon: 'menu-icon fas fa-store',
          route: '/reward/reward-category',
          actions: ['REWARD_PRODUCT_CATEGORY_VIEW'],
        },
        {
          name: 'Chương trình thưởng hoa hồng',
          icon: 'menu-icon fas fa-money-bill-alt',
          route: '/reward/reward-program',
          actions: ['REWARD_PROGRAM_VIEW'],
        },
        {
          name: 'Cộng trừ khác hoa hồng',
          icon: 'menu-icon fas fa-store',
          route: '/reward/reward-detail',
          actions: ['REWARD_DETAIL_VIEW'],
        },
        {
          name: 'Kiểm tra sản phẩm tính hoa hồng',
          icon: 'menu-icon fas fa-ticket-alt',
          route: '/reward/reward-check',
          actions: ['REWARD_CHECK_VIEW'],
        },
      ],
    },
  ],
  MY_ACCOUNT: [
    {
      name: 'Tài khoản của tôi',
      icon: 'menu-icon fas fa-gift',
      route: '#',
      submenu: [
        {
          name: 'Thay đổi mật khẩu',
          icon: 'menu-icon fas fa-key',
          route: '/profile/change-password',
          isVisible: true,
        },
        {
          name: 'Phiếu chuyển cửa hàng',
          icon: 'menu-icon fas fa-store',
          route: '/profile/transfer-store-forms',
          isVisible: true,
        },
        {
          name: 'Chuyển cửa hàng',
          icon: 'menu-icon fas fa-store',
          route: '/profile/change-store',
          isVisible: true,
        },
      ],
      isVisible: true,
    },
  ],
  EINVOICE: [
    {
      name: 'Hoá đơn điện tử',
      icon: 'menu-icon fas fa-file-invoice',
      route: '/einvoices',
      actions: ['EINVOICE_VIEW'],
    },
    {
      name: 'Cấu hình HĐĐT',
      icon: 'menu-icon fas fa-cogs',
      route: '/einvoices/config',
      actions: ['EINVOICE_CONFIG_VIEW'],
      // TODO(einvoice-permission): restore menu visibility to permission-driven behavior after UI review.
      isVisible: true,
    },
  ],
  FEATURE_FLAG: [
    {
      name: 'Quản lý Feature Flags',
      icon: 'menu-icon fas fa-flag',
      route: '/feature-flags',
      actions: ['FEATURE_FLAG_VIEW'],
    },
  ],
  PLATFORM_INTEGRATION: [
    {
      name: 'Kênh bán',
      icon: 'menu-icon la la-store',
      route: '#',
      actions: [
        'PLATFORM_INTEGRATION_VIEW',
        'PLATFORM_PRODUCT_MANAGE',
        'PLATFORM_ORDER_MANAGE',
        'PLATFORM_COMPLAINT_MANAGE',
        'PLATFORM_RECONCILIATION_MANAGE',
        'PLATFORM_PICK_LIST_REPORT_MANAGE',
        'PLATFORM_ORDER_REPORT_MANAGE',
        'PLATFORM_ORDER_FUNNEL_REPORT_MANAGE',
        'PLATFORM_BY_MARKETPLACE_REPORT_MANAGE',
        'PLATFORM_PROFIT_LOSS_REPORT_MANAGE',
        'PLATFORM_BY_PRODUCT_REPORT_MANAGE',
      ],
      submenu: [
        {
          name: 'Danh sách kết nối',
          icon: 'menu-icon flaticon2-list',
          route: '/platform-integration',
          actions: ['PLATFORM_INTEGRATION_VIEW'],
        },
        {
          name: 'Quản lý sản phẩm',
          icon: 'menu-icon flaticon2-box-1',
          route: '/platform-integration/products',
          actions: ['PLATFORM_PRODUCT_MANAGE'],
        },
        {
          name: 'Quản lý đơn hàng',
          icon: 'menu-icon flaticon2-list-3',
          route: '/platform-integration/orders',
          actions: ['PLATFORM_ORDER_MANAGE'],
        },
        {
          name: 'Quản lý đơn khiếu nại',
          icon: 'menu-icon flaticon2-exclamation',
          route: '/platform-integration/complaints',
          actions: ['PLATFORM_COMPLAINT_MANAGE'],
        },
        {
          name: 'Đối soát đơn hàng',
          icon: 'menu-icon flaticon2-checking',
          route: '/platform-integration/reconciliation',
          actions: ['PLATFORM_RECONCILIATION_MANAGE'],
        },
        {
          name: 'Báo cáo Pick-list RTS',
          icon: 'menu-icon flaticon2-list',
          route: '/platform-integration/reports/pick-list',
          actions: ['PLATFORM_PICK_LIST_REPORT_MANAGE'],
        },
        {
          name: 'Báo cáo đơn hàng',
          icon: 'menu-icon flaticon2-pie-chart-1',
          route: '/platform-integration/reports/order-report',
          actions: [
            'PLATFORM_ORDER_REPORT_MANAGE',
            'PLATFORM_ORDER_FUNNEL_REPORT_MANAGE',
            'PLATFORM_BY_MARKETPLACE_REPORT_MANAGE',
          ],
        },
        {
          name: 'Báo cáo lãi lỗ',
          icon: 'menu-icon flaticon2-box-1',
          route: '/platform-integration/reports/profit-loss',
          actions: ['PLATFORM_PROFIT_LOSS_REPORT_MANAGE', 'PLATFORM_BY_PRODUCT_REPORT_MANAGE'],
        },
        // {
        //   name: 'Quản lý tồn kho',
        //   icon: 'menu-icon flaticon2-box',
        //   route: '/platform-integration/inventory-logs',
        //   actions: [],
        // },
      ],
    },
  ],
}
